import { handleActions } from 'redux-actions';

import http from '../../../shared/http';
import endpoints from '../../../../config/endpoints';

export const namespace = 'blogArticleEditor';

// action types
const FETCH_DATA_SUCCESS = `${namespace}/fetch-data-success`;
const SET_INITIAL_VALUES = `${namespace}/set-initial-values`;
const FETCH_DATA_ERROR = `${namespace}/fetch-data-error`;
const TOGGLE_PROGRESS_BAR = `${namespace}/toggle-progress-bar`;

const FETCH_TAGS_SUCCESS = `${namespace}/fetch-tags-success`;
const FETCH_TAGS_ERROR = `${namespace}/fetch-tags-error`;

// initial state
const initialState = {
	data: null,
	isLoading: true,
	isError: false
};

const initialFormValues = {
	tags: null,
	language: null,
	image: '',
	title: '',
	description: '',
	content: ''
};

function mapResponseDataToStateData(data) {
	return {
		tags: data.tags.map((tag) => ({ value: tag.id, label: tag.name })),
		language: [{ value: data.language, label: data.language }],
		image: data.image,
		title: data.title,
		description: data.description,
		content: data.content
	};
}

function getCreateRequest(payload) {
	return http({
		url: endpoints.BLOG.ARTICLES,
		method: 'post',
		actions: [SET_INITIAL_VALUES, FETCH_DATA_ERROR],
		data: payload
	});
}

function getUpdateRequest(id, payload) {
	return http({
		url: `${endpoints.BLOG.ARTICLES}/${id}`,
		method: 'put',
		actions: [FETCH_DATA_SUCCESS, FETCH_DATA_ERROR],
		data: payload
	});
}

// actions
export const actions = {
	own: {
		fetchData: (props) => (dispatch) => {
			const id = props.params.id;

			if (!id) {
				return dispatch({ type: SET_INITIAL_VALUES });
			}

			const request = http({
				url: `${endpoints.BLOG.ARTICLES}/${id}`,
				method: 'get',
				actions: [FETCH_DATA_SUCCESS, FETCH_DATA_ERROR]
			});

			return request(dispatch);
		},
		onSubmit: (values, _, props) => (dispatch) => {
			const id = props.params.id;

			dispatch(actions.own.toggleProgressBar());

			const payload = {
				tag_ids: values.tags.map((option) => option.value),
				language: values.language[0].value,
				image: values.image.trim(),
				title: values.title.trim(),
				description: values.description.trim(),
				content: values.content
			};

			const request = id
				? getUpdateRequest(id, payload)
				: getCreateRequest(payload);

			return request(dispatch);
		},
		articleTagsLookup: (search) => (dispatch) => {
			const request = http({
				url: endpoints.LOOKUPS.ARTICLE_TAGS,
				method: 'get',
				actions: [FETCH_TAGS_SUCCESS, FETCH_TAGS_ERROR],
				query: { query: search }
			});

			return request(dispatch).then((action) => {
				if (action.type === FETCH_TAGS_SUCCESS) {
					return {
						options: action.payload.data.map(({ id, name }) => ({ value: id, label: name }))
					};
				}
			});
		},
		toggleProgressBar: () => ({ type: TOGGLE_PROGRESS_BAR })
	}
};

const reducers = Object.assign(
	{
		[FETCH_DATA_SUCCESS]: (state, action) => ({
			...state,
			data: mapResponseDataToStateData(action.payload.data),
			isLoading: false,
			isError: false
		}),
		[SET_INITIAL_VALUES]: (state, action) => ({
			...state,
			data: initialFormValues,
			isLoading: false,
			isError: false
		}),
		[FETCH_DATA_ERROR]: (state, action) => ({
			...state,
			isLoading: false,
			isError: true
		}),
		[TOGGLE_PROGRESS_BAR]: (state, action) => ({
			...state,
			isLoading: !state.isLoading
		})
	},
);

// reducers
export default handleActions(reducers, initialState);

// selectors
export const selectors = {
	select: (state, field) => state[namespace][field]
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/blog/article/editor/index.js